'use strict';

const cookieStorage = [
  'Storage',

  function (Storage) {
    return new Storage('cookie');
  }
];

export default cookieStorage;



// WEBPACK FOOTER //
// ./app/src/services/cookie_storage.js